export const navigation = {
  state: {
    noCache: new Date().getTime(),
    selectedMenu: 0,
    selectedTab: "turn"
  },
  reducers: {    
    setNoCache(state) {
      return {
        ...state,
        noCache: new Date().getTime(),
      };
    },
    setSelectedMenu(state, payload) {
      localStorage.setItem('selectedMenu', payload);
      return {
        ...state,
        selectedMenu: payload
      };
    },
    setSelectedTab(state, payload) {
      return {
        ...state,
        selectedTab: payload
      };
    },
  },
  effects: (dispatch) => ({
    async getSelectedMenuItemAsync(payload, rootState) {
      //Please increment an index here for each button added on DrawerContent component listItemLink component.
      if([0,1,2].includes(payload)){
          this.setSelectedMenu(payload)
        }else{
          const selectedMenu = await localStorage.getItem('selectedMenu');
              if (selectedMenu) {            
                this.setSelectedMenu(JSON.parse(selectedMenu));
              }
          }
        },
    async setSelectTabAsync(payload, rootState) {
      //Please increment an index here for each button added on DrawerContent component listItemLink component.
      this.setSelectedTab(payload)
  }}),
};
